/**
 * Automation module — request validation schemas.
 */
import { z } from 'zod';
/** A single chat turn's user message. Bounded to keep prompt sizes sane. */
export const AutomationChatSendSchema = z.object({
    message: z.string().trim().min(1).max(8000),
});
/** Body for resolving a previewed publish via the Confirm/Reject buttons. */
export const ResolveAutomationPendingActionSchema = z.object({
    decision: z.enum(['confirm', 'reject']),
});
/**
 * Admin: enable/disable the Automation module and set the Marketing Automation
 * Drive folders. All fields optional so the enable toggle and the folder card
 * can PATCH independently. Folder inputs accept a Drive URL or bare id; "" or
 * null clears the folder.
 */
export const PatchAutomationConfigSchema = z
    .object({
    enabled: z.boolean().optional(),
    visualsDriveFolderInput: z.string().max(500).nullable().optional(),
    brandedDriveFolderInput: z.string().max(500).nullable().optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'No fields to update' });
/** Admin: grant a user access to one automation. */
export const GrantAutomationAccessSchema = z.object({
    userId: z.string().uuid(),
    automationKey: z.string().trim().min(1).max(64),
});
//# sourceMappingURL=automation.schema.js.map